export default __webpack_public_path__ + "static/thumb-landscape-602ea7e45b65d47149261ab43f8b26ef.png";